import { render } from "./SavableRegion.vue?vue&type=template&id=61107d2c&scoped=true"
import script from "./SavableRegion.vue?vue&type=script&lang=js"
export * from "./SavableRegion.vue?vue&type=script&lang=js"

import "./SavableRegion.vue?vue&type=style&index=0&id=61107d2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61107d2c"]])

export default __exports__